import ArtworkPicker from './ArtworkPicker';

export default ArtworkPicker;
